import React, {  } from "react";
import '../scss/style.css';
import '../scss/dialog.css';
import { motion } from 'framer-motion';
import { wstepy } from '../functions/motions';

const DialogYesNo = ( props ) => {

    const { open, setOpen, message, message2 = "", f, id } = props;

    const onConfirm = () => {
        if (id !== null)
            f(id);
        else 
            f();
        setOpen(false);
    }
    
    const onCancel = () => {
        setOpen(false);
    }

    return (
        <motion.div 
            className= { open ? "dialog block" : "dialog none" } 
            variants={wstepy}
            initial="initial"
            animate="animate"
        >
            <div 
                className="window"
                style={{ 
                    whiteSpace: 'pre-line',
                    // maxHeight: '50vh',
                    overflow: 'auto'
                }}
            >
                <h3>{message}</h3>
                <span>{message2}</span>
                <div
                    className="buttons"    
                >
                    <button
                        onClick={onConfirm}
                    >
                        Tak
                    </button>
                    <button
                        onClick={onCancel}
                    >
                        Nie
                    </button>
                </div>
            </div>
        </motion.div>
    )
}

export default DialogYesNo;